<template>
	<svg
		width="15px"
		height="11px"
		viewBox="0 0 15 11"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="watch meeting icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="End-Meeting"
				transform="translate(-619.000000, -520.000000)"
				fill="#4F4F4F"
			>
				<g id="Group-37" transform="translate(533.000000, 323.000000)">
					<g id="Group-36" transform="translate(57.000000, 109.000000)">
						<g id="Group-35" transform="translate(1.000000, 73.000000)">
							<g id="Group-33" transform="translate(28.000000, 10.000000)">
								<path
									d="M7.41086931,5 C12.4857285,5 14.6096369,9.62850865 14.6096369,9.62850865 C14.8951399,10.1044536 14.88719,10.8847553 14.6172823,11.359375 C14.6172823,11.359375 12.4857285,16 7.41086931,16 C2.33601014,16 0.212101698,11.3714914 0.212101698,11.3714914 C-0.0734012546,10.8955464 -0.0654513694,10.1152447 0.2044563,9.640625 C0.2044563,9.640625 2.33601014,5 7.41086931,5 Z M7.41086931,7.75 C5.85756845,7.75 4.59836931,8.98121694 4.59836931,10.5 C4.59836931,12.0187831 5.85756845,13.25 7.41086931,13.25 C8.96417017,13.25 10.2233693,12.0187831 10.2233693,10.5 C10.2233693,10.4192028 10.2198057,10.3392194 10.2128236,10.260192 C9.93852221,10.4132289 9.6225593,10.5 9.28586931,10.5 C8.25033541,10.5 7.41086931,9.67918871 7.41086931,8.66666667 C7.41086931,8.33726274 7.49971815,8.02814942 7.65526179,7.76098842 C7.57509445,7.75347554 7.49339698,7.75 7.41086931,7.75 Z"
									id="Combined-Shape"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'WatchMeeting',
}
</script>
